import { render, staticRenderFns } from "./OptionalGroup.vue?vue&type=template&id=2b6b62f6&"
import script from "./OptionalGroup.vue?vue&type=script&lang=ts&"
export * from "./OptionalGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports